import { Payment } from '@linktivity/link-payment';

const CardNetwork = Payment.CardNetwork;
type CardNetwork = Payment.CardNetwork;

const PaymentStatus = Payment.PaymentStatus;
type PaymentStatus = Payment.PaymentStatus;

const PlatformType = Payment.PlatformType;
type PlatformType = Payment.PlatformType;

const PayMethod = Payment.PayMethod;
type PayMethod = Payment.PayMethod;

export { CardNetwork, PaymentStatus, PlatformType, PayMethod };
